var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar',{staticClass:"mb-3 mb-sm-4"}),_c('b-container',{staticClass:"px-sm-4 px-xl-5",attrs:{"fluid":""}},[_c('HomeBody',{staticClass:"mb-4"}),_c('Footer',{staticClass:"mb-4"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }